import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const CastIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"cast"} ref={ref}/>
});

CastIcon.displayName = "CastIcon";
